import { buildGlobalCssWithSectionStyleGenerators } from '../../utils/build-global-css/build-global-css';
import { buildCssMobile } from './build-css-mobile';
function getVisibilityCss(breakPoint) {
    const breakPointValue = parseInt(breakPoint || '480px', 10);
    return `
    @media all and (max-width: ${breakPoint || '480px'}) {
      .visibility-desktop-only {
        display: none!important;
      }
    }
    @media all and (min-width: ${breakPointValue + 1}px) {
      .visibility-mobile-only {
        display: none!important;
      }
    }
  `;
}
export function buildCss({ css, breakPoint, composerData, experiments, sections, buildForMobile, }) {
    return [
        `.so-link-href {text-decoration: none;}
    `,
        getVisibilityCss(breakPoint).trim(),
        buildForMobile ? buildCssMobile(css).trim() : '',
        buildGlobalCssWithSectionStyleGenerators({
            breakPoint,
            composerData,
            css,
            experiments,
            sections,
            buildForMobile,
        }).trim(),
    ].join('');
}
//# sourceMappingURL=build-css.js.map